fragment ProductForLeadFragment on LeadProductsEdge {
    id
    relationshipNote
    quantity
    price {
        currency
        symbol
        formattedWithCents
    }
    originalPrice {
        amount
    }
    total
    node {
        id
        name
        description
        type
        reportUrl
        term
        sku
        category {
            id
            name
        }
        markets {
            edges {
                price {
                    formattedWithCents
                }
                isAvailable
            }
        }
        createdTime
    }
}
